import { get } from 'api/request';

/**
 * 培训档案图片
 * @param applyNo 报名编号
 * @returns {Promise<*>}
 */
export function archiveInfo({ applyNo }, cfg = {}) {
    return get(
        this.url,
        {
            applyNo,
        },
        {
            ...cfg,
        },
    );
}
